/**
 * Edge media URL helpers.
 *
 * The edge (recv-rad) serves a live MJPEG feed at `.../{source_id}/stream`
 * and a single JPEG frame of the current moment at `.../{source_id}/snapshot`.
 * A `_raw` suffix on the source id selects the unannotated raw frame; without
 * it the edge returns the drawn (annotated) frame.
 *
 * `toSnapshotUrl` maps a stored `stream_url` (`.../{ip}/stream`) to the raw
 * snapshot endpoint (`.../{ip}_raw/snapshot`) so the UI renders one still raw
 * frame instead of holding an open MJPEG connection.
 */
export function toSnapshotUrl(streamUrl?: string | null): string {
  if (!streamUrl) return '';
  // Append `_raw` to the source-id segment and swap the trailing `/stream`
  // (optionally followed by a query string) for `/snapshot`. Anything that
  // does not match passes through unchanged.
  return streamUrl.replace(/\/([^/]+)\/stream(\?.*)?$/, '/$1_raw/snapshot$2');
}
